import { render, staticRenderFns } from "./MutasiAnggota.vue?vue&type=template&id=21ef0b78"
import script from "./MutasiAnggota.vue?vue&type=script&lang=js"
export * from "./MutasiAnggota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports